import { gql } from '@apollo/client';

export default gql`
  query getBookingItems($bookingReference: String!, $tariffCodes: [String]) {
    getBookingItems(bookingReference: $bookingReference, tariffCodes: $tariffCodes) {
      id
      costPrice {
        amount
        currency
      }
      costPriceInItemCurrency {
        amount
        currency
      }
      confirmedTimestamp
      predecessorInfo {
        operation
        itemIds
      }
    }
  }
`;
